<script setup lang="ts">

import { faArrowRightLong } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { AppIcon } from '@shared/ui/icons'
import { InputPrimary } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalConfirmPaymentPolicy } from '../../../model/payment-policy/modal-confirm-payment-policy.hook'

defineOptions({
  name: 'ModalConfirmPaymentPolicy',
})

const {
  refIsOpen,
  refIsLoading,
  refChanges,
  reasons,
  refIsValid,
  closeModal,
  saveChanges,
} = useModalConfirmPaymentPolicy()

const onReasonInput = (category: string, value: string | number | null): void => {
  reasons[category] = String(value ?? '')
}
</script>

<template>
  <ModalDefault
    :show="refIsOpen"
    :loading="refIsLoading"
    title="Confirm changes"
    is-close-button
    @click:overlay="closeModal"
    @click:close="closeModal"
  >
    <div
      v-for="change in refChanges"
      :key="change.category"
      class="modal-confirm-payment-policy__item"
    >
      <div class="modal-confirm-payment-policy__row">
        <AppText
          name="body2"
          color="slate-500"
          class="modal-confirm-payment-policy__label"
        >
          {{ change.label }}
        </AppText>
        <div class="modal-confirm-payment-policy__values">
          <AppText
            name="body2"
            class="modal-confirm-payment-policy__value"
            color="slate-700"
          >
            {{ change.oldName }}
          </AppText>
          <AppIcon
            :icon="faArrowRightLong"
            color="slate-700"
            size="small"
          />
          <AppText
            name="body2"
            class="modal-confirm-payment-policy__value"
            color="slate-700"
          >
            {{ change.newName }}
          </AppText>
        </div>
      </div>
      <InputPrimary
        :id="`reason-${change.category}`"
        type="textArea"
        label="Reason"
        required
        placeholder="Type the reason here"
        :value="reasons[change.category] ?? ''"
        @input="(event) => onReasonInput(change.category, event.value)"
      />
    </div>
    <template #controls>
      <BtnPrimary
        text="Save changes"
        color="emerald"
        :disabled="!refIsValid"
        @click="saveChanges"
      />
      <BtnSecondary
        text="Cancel"
        @click="closeModal"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalConfirmPaymentPolicy.scss" />
